export default __webpack_public_path__ + "static/media/basketball-img.6f30acf0.svg";